import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import './addGuideline.css'
import LoadingPage from '../Loading/loading';
import { deleteGuideline, getGuideline, updateGuideline } from '../../api/guideline';
import { Link } from 'react-router-dom';
import { Cookies } from 'react-cookie';

const GuidelineComponent = (props) => {
    const [guidelines, setGuidelines] = useState(null);
    const [id, setId] = useState('');
    const [idUpdate, setIdUpdate] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        setGuidelines(null)
        getGuideline(props.user).then((result) => {
            setGuidelines(result.data.response)
        })
    }, [])

    const guidelineDelete = (id) => {
        deleteGuideline(id).then((result) => {
            setGuidelines(guidelines.filter(getGuideline => getGuideline._id !== id));
        })
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const update = () => {
        setLoading(true)
        updateGuideline(formData._id, formData.name_en, formData.name_ar, formData.video).then((result) => {
            getGuideline(props.user).then((result) => {
                setGuidelines(result.data.response)
                setIdUpdate("")
                setFormData(null)
                setLoading(false)
            })
        })
    };

    return (
        <>{guidelines === null ? < LoadingPage /> : <div>
            <div className="card-cards">
                {guidelines?.map(guideline => (
                    <div key={guideline._id} className={`card-card`}>
                        {idUpdate === guideline._id ? <div style={{ width: "100%" }}>
                            <div className="form-group">
                                <label htmlFor="name_en">Question english</label>
                                <input
                                    type="text"
                                    id="name_en"
                                    name="name_en"
                                    value={formData.name_en}
                                    onChange={handleChange}
                                    placeholder="Enter English"
                                    required
                                    onInvalid={(e) => e.target.setCustomValidity("English is required")}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="name_ar">Question arabic</label>
                                <input
                                    type="text"
                                    id="name_ar"
                                    name="name_ar"
                                    value={formData.name_ar}
                                    onChange={handleChange}
                                    placeholder="Enter Arabic"
                                    dir="rtl"
                                    required
                                    onInvalid={(e) => e.target.setCustomValidity("Arabic is required")}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="video">Video</label>
                                <input
                                    type="text"
                                    id="video"
                                    name="video"
                                    value={formData.video}
                                    onChange={handleChange}
                                    placeholder="Enter video"
                                    required
                                    onInvalid={(e) => e.target.setCustomValidity("Video is required")}
                                />
                            </div>

                            {loading ? <div style={{
                                width: "100%",
                                justifyContent: "center",
                                display: "flex"
                            }}>
                                <div className="spinner"></div>
                            </div> : <div className="card-info">
                                <div className="card-actions">
                                    <button
                                        onClick={() => {
                                            setFormData(null)
                                            setIdUpdate("")
                                        }}
                                        className="action-btn remove-btn"
                                    >
                                        No
                                    </button>
                                </div>
                                <div className="card-actions">
                                    <button
                                        onClick={() => { update() }}
                                        className="action-btn accept-btn"
                                    >
                                        Update guideline
                                    </button>
                                </div>
                            </div>}
                        </div> : <div className="card-info">
                            <div>
                                <p className='line'><span className="label">English:</span> {guideline.name_en}</p>
                                <p className='line'><span className="label">Arabic:</span> {guideline.name_ar}</p>
                                {(id === guideline._id) && < div style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "5px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <p className='line'>Are you sure you want to delete this guideline? </p>
                                    <div className="card-info">
                                        <div className="card-actions">
                                            <button
                                                onClick={() => { setId("") }}
                                                className="action-btn accept-btn"
                                            >
                                                No
                                            </button>
                                        </div>
                                        <div className="card-actions">
                                            <button
                                                onClick={() => { guidelineDelete(guideline._id) }}
                                                className="action-btn remove-btn"
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                        }

                        {(id !== guideline._id && idUpdate !== guideline._id) && <div className="card-actions">
                            <Link
                                target='_blank'
                                to={guideline.video}
                                className={`action-btn accept-btn`}
                            >
                                Video
                            </Link>
                            {props.isSuper && <><button
                                onClick={() => {
                                    setFormData(guideline)
                                    setIdUpdate(guideline._id)
                                }}
                                className="action-btn ban-btn"
                            >
                                Edit
                            </button>
                                <button
                                    onClick={() => { setId(guideline._id) }}
                                    className="action-btn remove-btn"
                                >
                                    Delete
                                </button></>}
                        </div>}
                    </div>
                ))}
            </div>
        </div>}</>
    );
};

export default GuidelineComponent;